import { FC, SVGProps } from 'react';

export const UnlinkIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M16.125 20.25V18.1875M18.1875 16.125H20.25M6.89531 11.2709L5.43713 12.7291C4.66352 13.5027 4.22891 14.5519 4.22891 15.646C4.22891 16.74 4.66352 17.7893 5.43713 18.5629C6.21073 19.3365 7.25997 19.7711 8.35402 19.7711C9.44806 19.7711 10.4973 19.3365 11.2709 18.5629L12.7301 17.1047M5.8125 7.875H3.75M7.875 3.75V5.8125M11.2709 6.89531L12.7291 5.43713C13.1106 5.04708 13.5656 4.73658 14.0679 4.52362C14.5703 4.31065 15.1098 4.19944 15.6554 4.19644C16.201 4.19343 16.7417 4.29869 17.2464 4.50611C17.751 4.71353 18.2094 5.019 18.5952 5.40482C18.9809 5.79064 19.2863 6.24916 19.4937 6.75381C19.701 7.25847 19.8061 7.79924 19.803 8.34482C19.7999 8.8904 19.6886 9.42994 19.4756 9.93221C19.2625 10.4345 18.952 10.8895 18.5618 11.2709L17.1037 12.7291"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
